import React, { useEffect } from 'react'
import Layout from "@wrappers/layouts/main-layout/Layout";
import { internationalizeNumericValue, setCookieData } from '@/ts/utils';
import { useSelector } from 'react-redux';
import { IAdminToggleBtn, IChannel, IValueNumber, TReportsData, TSelectedReportData } from '@/ts/common-types';
import useGetModulesData from '@/hooks/useGetModulesData';
import measurementIcon from "@images/measure.png"
import IOTIcon from "@images/IOT.png"
import revscoutIcon from "@images/revscout.png"
import { usePermissionCheck } from '@/hooks/AllCustomHooks';

const MeasurementHomePage = () => {

    useEffect(() => {
        document.title = `Measurement | REVINITI`;
    }, []);

    const channelWalletBalance = useSelector(
        (state: IChannel) => state.channelWalletBalance.value
    );
    const currencySymbol = useSelector(
        (state: IChannel) => state.channelCurrencySymbol.value
    );
    const selectedReportData = useSelector(
        (state: TSelectedReportData) => state.selectedReportData.value
    );
    const enableRevstack = useSelector(
        (state: IAdminToggleBtn) => state.enableRevstack.value
    );

    const routesData = useGetModulesData({ type: "routes" });
    const reportsData = useSelector(
        (state: TReportsData) => state.reportsData.value
    );

    const clientGroup = useSelector(
        (state: { activeClientGroupId: IValueNumber }) =>
            state.activeClientGroupId.value
    );

    const { canManageAdminSettings } = usePermissionCheck()

    const redirectToIOT = () => {
        const isDevInstance = process.env.VITE_NODE_ENV === "local";
        const redirectUrl = isDevInstance
            ? window.location.host
            : process.env.VITE_IOT_REDIRECT;
        const redirectionData = {
            channelWalletBalance:
                internationalizeNumericValue(channelWalletBalance),
            currencySymbol,
            selectedReportData,
            canManageAdminSettings,
            enableRevstack,
            routesData,
            reportsData,
            clientGroup,
        };

        setCookieData("redirection_data", JSON.stringify(redirectionData));
        window.location.href = redirectUrl;
    };



    const redirectToReportsBuilder = () => {
        // const accessToken = getCookieData("access_token");
        // const refreshToken = getCookieData("refresh_token");
        // const domainArr = window.location.hostname.split(".");
        const isDevInstance = process.env.VITE_NODE_ENV === "local";
        // const domain = isDevInstance
        //     ? null
        //     : `domain=${domainArr.slice(-2).join(".")}`;
        const redirectUrl = isDevInstance
            ? window.location.host
            : process.env.VITE_REPORTS_BUILDER_HOST;

        // // Adding 30 seconds validity
        // const expiresInMinutes = 0.5;
        // const now = new Date();
        // now.setTime(now.getTime() + expiresInMinutes * 60 * 1000);
        // const expires = "expires=" + now.toUTCString();
        // const redirectionData = {
        //     channelWalletBalance:internationalizeNumericValue(channelWalletBalance),
        //     currencySymbol,
        //     selectedReportData,
        //     isAdminAccount,
        //     enableRevstack,
        //     routesData,
        //     reportsData,
        // };
        // document.cookie = `redirection_data=${JSON.stringify(redirectionData)}; ${domain}; path=/; ${expires}`;
        // document.cookie = `access_token=${accessToken}; ${domain}; path=/; ${expires}`;
        // document.cookie = `refresh_token=${refreshToken}; ${domain}; path=/; ${expires}`;
        window.location.href = `${redirectUrl}/dashboard/list`;
    };

    return (


        <Layout>
            <div className="measurement-homepage-container">
                <div className="mb-6">
                    <div className="d-flex align-items-center mb-2">
                        <img
                            src={measurementIcon}
                            alt="Measurement Icon"
                            className="measurement-page-logos"
                        />
                        <h2 className="m-0">Measurement</h2>
                    </div>
                    <p>
                        Go to the following tools to get insights on your data.
                    </p>
                </div>

                {/* Cards Section */}
                <div className="row w-100">
                    {/*<div className="col-md-2  mb-3">
                        <div className="card h-100" onClick={redirectToIOT}>
                            <div className="card-body px-5 py-6">
                                <div className="mb-3 d-flex align-items-center justify-content-center">
                                    <img
                                        src={IOTIcon}
                                        alt="Insights Icon"
                                        className="measurement-page-card-logos"
                                    />
                                </div>
                                <h6 className="card-title text-center">Insights on Tap</h6>
                            </div>
                        </div>
                    </div>*/}

                    <div className="col-md-2 mb-3">
                        <div className="card h-100" onClick={redirectToReportsBuilder}>
                            <div className="card-body px-5 py-6">
                                <div className="mb-3 d-flex align-items-center justify-content-center">
                                    <img
                                        src={revscoutIcon}
                                        alt="Revscout Icon"
                                        className="measurement-page-card-logos"
                                    />
                                </div>
                                <h6 className="card-title text-center">Revscout</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>

    )
}

export default MeasurementHomePage